export enum CustomerConfirmStatusDetails {
  CustomerPayed = 'customer_payed',
}

export enum CancelStatusDetails {
  CancelledNewTimeout = 'new_timeout',
  CancelledRequisitesTimeout = 'requisites_timeout',
  CancelledSyncRequisitesAttempts = 'sync_requisites_attempts',
  CancelledCustomerConfirmTimeout = 'customer_confirm_timeout',
  CancelledCustomerAlternativesExhausted = 'customer_alternatives_exhausted',
  TraderConfirmTimeout = 'trader_confirm_timeout',
}

export enum NewStatusDetails {
  NewStartPaymentSyncAttempt = 'start_payment_sync_attempt',
  NewTradeMethodReset = 'trade_method_reset',
}

export enum DisputeStatusDetails {
  TraderConfirmTimeout = 'trader_confirm_timeout',
}
